/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentRadiation } from 'app/shared/model/treatment-radiation.model';
import { IRadiationBeamParameter } from 'app/shared/model/radiation-beam-parameter.model';

export interface ITreatmentRadiationBeamParam {
  id?: string;
  administeredValue?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  radiationSession?: ITreatmentRadiation | null;
  treatmentBeamParam?: IRadiationBeamParameter | null;
}

export const defaultValue: Readonly<ITreatmentRadiationBeamParam> = {
  active: false,
};
